import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import ErrorBoundary from './components/ErrorBoundary.tsx'

// Import the background image to ensure it gets included in the build
import './assets/gradient-bg.jpg'

// Import the logo to ensure it gets included in the build
import '/lovable-uploads/e421b9ec-b227-48fe-b38d-36ec913a24ed.png'

// The service worker makes the app installable (Settings > App) and receives push
// notifications. The browser's install prompt arrives once, early, so keep it for later.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${import.meta.env.BASE_URL}sw.js`, { scope: import.meta.env.BASE_URL })
      .catch(() => {})
  })
}
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  ;(window as any).__athiosInstallPrompt = event
  window.dispatchEvent(new Event('athios:installable'))
})

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
)
